import {
  Reinstate_offers,
  Reinstate_offersVariables,
} from "_graphql/kek/queries/__generated__/Reinstate_offers";

import { getReinstateOffers } from "_graphql/kek/queries/offers.kek";
import { useQuery } from "@apollo/client";

export const useReinstatementOffers = (
  variables: Reinstate_offersVariables
) => {
  const { data, ...rest } = useQuery<
    Reinstate_offers,
    Reinstate_offersVariables
  >(getReinstateOffers, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  const summary = {
    total: data?.data?.total || 0,
    active: data?.data?.active || 0,
    expired: data?.data?.expired || 0,
  };
  return {
    summary,
    offers: data?.data?.offers || [],
    count: data?.data?.total || 0,
    ...rest,
  };
};
